import { updateFiltersFront, setKeyFilterSelected } from "../../../redux/actions/logActions";
import connect from "react-redux/es/connect/connect";
import Filter from "../../../components/filter/Filter";

const mapStateToProps = (state, ownProps) => {
  return {
    filters:
      state.log && state.log.filters && Array.isArray(state.log.filters[ownProps.filterTargetKey])
        ? state.log.filters[ownProps.filterTargetKey]
        : [],
    currentFilters: state.log.currentFilters ? state.log.currentFilters[ownProps.filterTargetKey] : [],
    deps: ownProps.depKey && state.log.currentFilters ? state.log.currentFilters[ownProps.depKey] || [] : [],
    filterTargetKey: ownProps.filterTargetKey,
    placeholder: ownProps.placeholder
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values => {
      dispatch(updateFiltersFront(ownProps.filterTargetKey, values));
    },
    setKeyFilterSelected: () => dispatch(setKeyFilterSelected(ownProps.filterTargetKey))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// src/containers/activite/log/FilterContainer.js